import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from "react";
import styled from "styled-components";
export var Title = styled.h4(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 8px;\n  line-height: 20px;\n  margin-bottom: 16px;\n  //margin-top: 32px;\n  font-size: 20px;\n  font-weight: normal;\n  vertical-align: bottom;\n  box-sizing: border-box;\n  border-bottom: 1px solid #f1f1f1;\n  :before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 8px;\n    bottom: 8px;\n    width: 3px;\n    background: #40a9ff;\n  }\n"])));
export var TitleTail = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-left: 8px;\n  font-size: 16px;\n  color: #666;\n"])));
var SectionTitle = function SectionTitle(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    titleTail = _ref.titleTail,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement(Title, {
    style: style
  }, title, /*#__PURE__*/React.createElement(TitleTail, null, titleTail));
};
export default SectionTitle;